import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing, palette }) => ({
  header: {
    marginBottom: spacing(3)
  },
  contentTotal: {
    color: palette.text.secondary,
    marginLeft: spacing(1)
  },
  gridHeader: {
    height: 60,
    borderBottom: '1px solid #E0E0E0',
    paddingLeft: spacing(3)
  },
  tablePaper: {
    border: '1px solid rgba(0, 0, 0, 0.12)'
  },
  tableHead: {
    fontSize: 14,
    fontWeight: 700,
    letterSpacing: 0.25
  },
  dateUpdatedHeader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& svg': {
      marginRight: spacing(1)
    }
  },
  loadMoreBtn: {
    margin: spacing(5, 0)
  },
  loadingAnimation: {
    margin: spacing(5)
  },
  emptyList: {
    minHeight: spacing(30),
    color: palette.text.secondary
  }
}))
